window.DocumentTouch = undefined;
const touch = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

  const mq = function(query) {
    return window.matchMedia(query).matches;
  };

  if (
    'ontouchstart' in window ||
    // eslint-disable-next-line no-undef
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(
    '',
  );
  return mq(query);
};

const device = () => {
  if (touch()) {
    document.getElementsByTagName('html')[0].classList.add('touch');
  }
};

const desktop = () => {
  if (window.innerWidth > 1023) {
    return true;
  }
  return false;
};

export default { device, touch, desktop };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/device.js